import React, {Component} from 'react';
import { connect } from 'react-redux'; 
import { Row, Col, Container} from 'react-bootstrap';
import CategoryFilter from '../components/services-category-filter';

import { fetchAllCaseStudies } from '../redux/actions/actions';

class Gallery extends Component {
  componentDidMount() {
    let { loadCaseStudies } = this.props;
    console.log("this is working");
    loadCaseStudies();
  }

  render() {
    return(
      <Container className="le-gallery-page">
        <div className="header">
          <h1>Our Works</h1>
          <p>HOME . GALLERY</p>
        </div>
        <CategoryFilter loadMore={false} articleList={this.props.articleList?this.props.articleList:null} />
      </Container>
    )
  }
}

const mapStateToProps = ({linenedges}) => ({
  articleList: linenedges.allCaseStudies
});  

const mapDispatchToProps = dispatch => ({
  loadCaseStudies: async () => await dispatch(fetchAllCaseStudies())
});

export default connect(mapStateToProps, mapDispatchToProps)(Gallery);